export const SET_COURSES_OVERVIEW = 'SET_COURSES_OVERVIEW'
export const SET_COURSES_OVERVIEW_LOADING = 'SET_COURSES_OVERVIEW_LOADING'
